import { type ITooltipProps } from 'shared/ui'

export const getLimitReachedTooltip = (isPersonal = false): ITooltipProps => {
  return {
    type: 'description',
    label: 'Limit reached',
    desc: `Deselect ${isPersonal ? 'someone' : 'something'} to add more`,
    placement: 'right',
    disableInteractive: true,
    fullWidth: true,
  }
}
